module.exports = __webpack_public_path__ + "img/push_logo.f7e2331b.svg";